function normalizeFilterValues(
  filter: string | string[] | null | undefined,
): string[] {
  if (!filter) return []
  const values = Array.isArray(filter) ? filter : [filter]
  return values
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean)
}

export function matchesStringArrayField(
  values: string[] | undefined,
  filter: string | string[] | null | undefined,
): boolean {
  const targets = normalizeFilterValues(filter)
  if (!targets.length) return true
  if (!values?.length) return false
  return values.some((value) =>
    targets.includes(value.trim().toLowerCase()),
  )
}

export function matchesScalarField(
  value: string | number | null | undefined,
  filter: string | string[] | null | undefined,
): boolean {
  const targets = normalizeFilterValues(filter)
  if (!targets.length) return true
  if (value == null || value === "") return false
  return targets.includes(String(value).trim().toLowerCase())
}

export type ActiveGridFilter = {
  key: string
  label: string
  value: string
}
